import { FieldError, FieldErrors } from 'react-hook-form';

export const findErrorMessage = (errors: FieldErrors, name: string): string => {
  // If the name doesn't include a dot, it's a top-level field
  if (!name.includes('.')) return (errors[name]?.message as string) || '';

  // Otherwise, we need to traverse the object to find the error message
  const keys = [...name.split('.')];
  let current: FieldError | FieldErrors = errors;
  while (keys.length > 0) {
    const currentKey = keys[0];
    // @ts-ignore
    current = current[currentKey];
    if (!current) return '';
    // @ts-ignore
    if (current.message) return current.message || '';
    keys.shift();
  }

  return '';
};
